import { FC, ReactNode } from 'react';
import styled from 'styled-components';

import { PremierText } from '@components/text';
import { SKEW_ANGLE } from '@utils/constants';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  background-color: ${({ theme }) =>
    `${theme.colors.black}${theme.opacity[60]}`};
  transform: skew(-${SKEW_ANGLE}deg);
`;

const Text = styled(PremierText)`
  font-size: ${({ theme }) => theme.fonts.fontSize.xs};
  color: ${({ theme }) => theme.colors.white};
  transform: skew(${SKEW_ANGLE}deg);
`;

type Props = {
  children: ReactNode;
};

const SkewedLabel: FC<Props> = ({ children }) => {
  return (
    <Container>
      {typeof children === 'string' ? <Text>{children}</Text> : children}
    </Container>
  );
};

export default SkewedLabel;
